<!-- eslint-disable @angular-eslint/template/alt-text -->
<ion-header>
  <ion-toolbar mode="ios" [class.socialModal--noPreview]="!imagePreviewSrc">
    <ion-buttons slot="start">
      <ion-button mode="md" (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close" />
      </ion-button>
    </ion-buttons>

    <ion-title>{{ 'txt-share' | tr }}</ion-title>
  </ion-toolbar>
</ion-header>

@if (!!imagePreviewSrc) {
  <ion-content class="ion-padding">
    <div class="socialModal__preview ion-padding-horizontal">
      <img class="socialModal__image" [src]="imagePreviewSrc" />
    </div>
  </ion-content>
}

<ion-footer>
  <ion-button expand="block" shape="round" (click)="share()" loader>
    <ion-label>{{ 'txt-share' | tr }}</ion-label>
  </ion-button>
</ion-footer>
